export const menuStyle = {
  // display: 'flex',
  // justifyContent: 'flex-start',
  // margin: '0 auto',
  // width: '100%',
  // backgroundColor: 'green',
}
